import cmsAU from './cms-au.json';
import cmsNZ from './cms-nz.json';

export default {
    'au': cmsAU,
    'nz': cmsNZ
};